import { render, staticRenderFns } from "./AdminLock.vue?vue&type=template&id=4bc1c26b&scoped=true"
import script from "./AdminLock.vue?vue&type=script&lang=js"
export * from "./AdminLock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc1c26b",
  null
  
)

export default component.exports